import Vue from 'vue'
import {createApp} from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue'
import  router from './common/router/router';
import  store from './common/store/index.js'
import 'ant-design-vue/dist/reset.css';
import '@/static/css/ocps-food-iconfont.css';
import axios from 'axios'
import VueAxios from 'vue-axios'
import config from './config/config.js'
import utils from '@/common/utils.js'
import routes from '@/common/router/routes'
import i18n from "@/common/i18n/i18n";
import global from "@/static/css/global.css"
import auth from "@/common/auth.js"
import EventBus from '@/common/event-bus.js'
import VueClipboard from 'vue-clipboard2';




const app = createApp(App)

store.commit("menuList", utils.getMenuByRouter(routes));

//自己实现eventbus
const $bus = new EventBus()
app.provide('$bus', $bus)
// 2.挂载到this上
app.config.globalProperties.$bus = $bus

auth.getLocalToken();
auth.getUserBasicInfo(function (user) {
    $bus.emit("userInfoUpdate", user);
});
auth.updateUserInfoNum(function (data) {
    $bus.emit("userInfoNumUpdate", data);
});


app.use(VueClipboard);
app.use(router)
app.use(store)
app.use(Antd)
app.use(i18n)
app.use(global);



app.use(VueAxios, axios)
app.mount('#app')



